import { Icon } from "@/components/icons/Icon";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { cn } from "@/lib/styles.utils";
import type { FC } from "react";

interface QuestionsModalHeaderProps {
  title: string;
  closed?: boolean;
  close?: VoidFunction;
}

const QuestionModalHeader: FC<QuestionsModalHeaderProps> = ({
  title,
  closed,
  close,
}) => {
  const translate = useTranslate();

  const handleOnClose = () => {
    close?.();
  };

  return (
    <div data-testid="question-modal-header">
      <div>
        {closed && (
          <button
            type="button"
            onClick={handleOnClose}
            className="flex items-center space-x-2 text-ib-red-main hover:underline pb-3"
          >
            <Icon name="chevronLeft" className="size-4" />
            <span className="text-base">{translate("goBack")}</span>
          </button>
        )}
        <div className={cn("flex justify-between")}>
          <div className=" flex-1 flex items-center space-x-4">
            <h3 className="text-3xl">{title}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionModalHeader;
